// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueConfigMessagerie = (newValue) => ({
  type: actionTypes.SET_VALUE_CONFIG_MESSAGERIE,
  payload: newValue,
});

export const setStatutConfigMessagerie = (newValue) => ({
  type: actionTypes.SET_STATUT_CONFIG_MESSAGERIE,
  payload: newValue,
});
export const setCurrentPageConfigMessagerie = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_CONFIG_MESSAGERIE,
  payload: newCurrentPage,
});

export const setSortFieldConfigMessagerie = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_CONFIG_MESSAGERIE,
  payload: newSortField,
});
export const setOrderConfigMessagerie = (newOrder) => ({
  type: actionTypes.SET_ORDER_CONFIG_MESSAGERIE,
  payload: newOrder,
});
